import React from "react";
import { DiscordOutlinedSVG, FacebookOutlinedSVG, InstagramOutlinedSVG, RedditSVG, SnapChatSVG, TelegramOutlinedSVG, TiktokOutlinedSVG, TwitchOutlinedSVG, TwitterOutlinedSVG, YoutubeOutlinedSVG } from "../svg/socials/Socials"
import { ManyVidsWhiteSVG } from "../svg/ManyVidsWhiteSVG";
import { ManyVidsGreySVG } from "../svg/ManyVidsGreySVG";
import { OnlyFansWhiteSVG } from "../svg/OnlyFansWhiteSVG";
import { OnlyFansGreySVG } from "../svg/OnlyFansGreySVG";
import { OnlyFansTVWhiteSVG } from "../svg/OnlyFansTVWhiteSVG";
import { OnlyFansTVGreySVG } from "../svg/OnlyFansTVGreySVG";
import { MyFreeCamWhiteSVG } from "../svg/MyFreeCamWhiteSVG";
import { MyFreeCamGreySVG } from "../svg/MyFreeCamGreySVG";
import { ChaturbateWhiteSVG } from "../svg/ChaturbateWhiteSVG";
import { ChaturbateGreySVG } from "../svg/ChaturbateGreySVG";

export const CATEGORY_ICONS = {
  'Chaturbate': '/platforms/chaturbate-logo-colored.png',
  'Clips4Sale': '/platforms/clips4sale-logo-colored.png',
  'Fansly': '/platforms/fansly-logo-colored.png',
  'iWantClips': '/platforms/iwantclips-logo-colored.png',
  'JustForFans': '/platforms/justforfans-logo-colored.png',
  'ManyVids': '/platforms/manyvids-logo-colored.png',
  'MyFreeCams': '/platforms/myfreecam-logo-colored.png',
  'OnlyFans': '/platforms/onlyfans-logo-colored.png',
  'OnlyFansTV': '/platforms/onlyfanstv-logo-colored.png',
  'Pornhub': '/platforms/pornhub-logo-colored.png',
  'Stripchat': '/platforms/stripchat-logo-colored.png',
  'XVideos': '/platforms/xvideos-logo-colored.png',
  'Discord': '/socials/discord-logo-colored.png',
  'Facebook': '/socials/facebook-logo-colored.png',
  'Instagram': '/socials/instagram-logo-colored.png',
  'Reddit': '/socials/reddit-logo-colored.png',
  'Snapchat': '/socials/snapchat-logo-colored.png',
  'Telegram': '/socials/telegram-logo-colored.png',
  'Tiktok': '/socials/tiktok-logo-colored.png',
  'Twitch': '/socials/twitch-logo-colored.png',
  'X': '/socials/x-logo-colored.png',
  'Youtube': '/socials/youtube-logo-colored.png',
};

export const WHITE_PLATFORM_ICONS = {
  'Chaturbate': '/platforms/chaturbate-logo-white.png',
  'Clips4Sale': '/platforms/clips4sale-logo-white.png',
  'Fansly': '/platforms/fansly-logo-white.png',
  'iWantClips': '/platforms/iwantclips-logo-white.png',
  'JustForFans': '/platforms/justforfans-logo-white.png',
  'ManyVids': '/platforms/manyvids-logo-white.png',
  'MyFreeCams': '/platforms/myfreecam-logo-white.png',
  'OnlyFans': '/platforms/onlyfans-logo-white.png',
  'OnlyFansTV': '/platforms/onlyfanstv-logo-white.png',
  'Pornhub': '/platforms/pornhub-logo-white.png',
  'Stripchat': '/platforms/stripchat-logo-white.png',
  'XVideos': '/platforms/xvideos-logo-white.png',
};

export const WHITE_OUTLINED_ICONS = {
  'Discord': <DiscordOutlinedSVG />,
  'Facebook': <FacebookOutlinedSVG />,
  'Instagram': <InstagramOutlinedSVG />,
  'Reddit': <RedditSVG />,
  'Snapchat': <SnapChatSVG />,
  'Telegram': <TelegramOutlinedSVG />,
  'Tiktok': <TiktokOutlinedSVG />,
  'Twitch': <TwitchOutlinedSVG />,
  'X': <TwitterOutlinedSVG />,
  'Youtube': <YoutubeOutlinedSVG />
};

export const FILTER_ICONS_WHITE = {
  'Manyvids': <ManyVidsWhiteSVG />,
  'OnlyFans': <OnlyFansWhiteSVG />,
  'OnlyFansTV': <OnlyFansTVWhiteSVG />,
  'MyFreeCams': <MyFreeCamWhiteSVG />,
  'Chaturbate': <ChaturbateWhiteSVG />
};

export const FILTER_ICONS_GREY = {
  'Manyvids': <ManyVidsGreySVG />,
  'OnlyFans': <OnlyFansGreySVG />,
  'OnlyFansTV': <OnlyFansTVGreySVG />,
  'MyFreeCams': <MyFreeCamGreySVG />,
  'Chaturbate': <ChaturbateGreySVG />
};